/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { McpServer } from "@modelcontextprotocol/sdk/server/mcp.js";
import { UapiMcpCore } from "../core.js";
import { SDKOptions } from "../lib/config.js";
import type { ConsoleLogger } from "./console-logger.js";
import { createRegisterPrompt } from "./prompts.js";
import {
  createRegisterResource,
  createRegisterResourceTemplate,
} from "./resources.js";
import { MCPScope } from "./scopes.js";
import { createRegisterTool, registerDynamicTools } from "./tools.js";
import { tool$clipzyGetClipzyGet } from "./tools/clipzyGetClipzyGet.js";
import { tool$clipzyGetClipzyRaw } from "./tools/clipzyGetClipzyRaw.js";
import { tool$clipzyPostClipzyStore } from "./tools/clipzyPostClipzyStore.js";
import { tool$convertGetConvertUnixtime } from "./tools/convertGetConvertUnixtime.js";
import { tool$convertPostConvertJson } from "./tools/convertPostConvertJson.js";
import { tool$dailyGetDailyNewsImage } from "./tools/dailyGetDailyNewsImage.js";
import { tool$gameGetGameEpicFree } from "./tools/gameGetGameEpicFree.js";
import { tool$gameGetGameMinecraftHistoryid } from "./tools/gameGetGameMinecraftHistoryid.js";
import { tool$gameGetGameMinecraftServerstatus } from "./tools/gameGetGameMinecraftServerstatus.js";
import { tool$gameGetGameMinecraftUserinfo } from "./tools/gameGetGameMinecraftUserinfo.js";
import { tool$gameGetGameSteamSummary } from "./tools/gameGetGameSteamSummary.js";
import { tool$getSearchEngines } from "./tools/getSearchEngines.js";
import { tool$getSensitiveWordAnalyzeQuery } from "./tools/getSensitiveWordAnalyzeQuery.js";
import { tool$imageGetAvatarGravatar } from "./tools/imageGetAvatarGravatar.js";
import { tool$imageGetImageBingDaily } from "./tools/imageGetImageBingDaily.js";
import { tool$imageGetImageMotou } from "./tools/imageGetImageMotou.js";
import { tool$imageGetImageQrcode } from "./tools/imageGetImageQrcode.js";
import { tool$imageGetImageTobase64 } from "./tools/imageGetImageTobase64.js";
import { tool$imagePostImageCompress } from "./tools/imagePostImageCompress.js";
import { tool$imagePostImageFrombase64 } from "./tools/imagePostImageFrombase64.js";
import { tool$imagePostImageMotou } from "./tools/imagePostImageMotou.js";
import { tool$imagePostImageNsfw } from "./tools/imagePostImageNsfw.js";
import { tool$imagePostImageSpeechless } from "./tools/imagePostImageSpeechless.js";
import { tool$imagePostImageSvg } from "./tools/imagePostImageSvg.js";
import { tool$miscGetHistoryProgrammer } from "./tools/miscGetHistoryProgrammer.js";
import { tool$miscGetHistoryProgrammerToday } from "./tools/miscGetHistoryProgrammerToday.js";
import { tool$miscGetMiscDistrict } from "./tools/miscGetMiscDistrict.js";
import { tool$miscGetMiscHolidayCalendar } from "./tools/miscGetMiscHolidayCalendar.js";
import { tool$miscGetMiscHotboard } from "./tools/miscGetMiscHotboard.js";
import { tool$miscGetMiscLunartime } from "./tools/miscGetMiscLunartime.js";
import { tool$miscGetMiscPhoneinfo } from "./tools/miscGetMiscPhoneinfo.js";
import { tool$miscGetMiscRandomnumber } from "./tools/miscGetMiscRandomnumber.js";
import { tool$miscGetMiscTimestamp } from "./tools/miscGetMiscTimestamp.js";
import { tool$miscGetMiscTrackingCarriers } from "./tools/miscGetMiscTrackingCarriers.js";
import { tool$miscGetMiscTrackingDetect } from "./tools/miscGetMiscTrackingDetect.js";
import { tool$miscGetMiscTrackingQuery } from "./tools/miscGetMiscTrackingQuery.js";
import { tool$miscGetMiscWeather } from "./tools/miscGetMiscWeather.js";
import { tool$miscGetMiscWorldtime } from "./tools/miscGetMiscWorldtime.js";
import { tool$miscPostMiscDateDiff } from "./tools/miscPostMiscDateDiff.js";
import { tool$networkGetNetworkDns } from "./tools/networkGetNetworkDns.js";
import { tool$networkGetNetworkIcp } from "./tools/networkGetNetworkIcp.js";
import { tool$networkGetNetworkIpinfo } from "./tools/networkGetNetworkIpinfo.js";
import { tool$networkGetNetworkMyip } from "./tools/networkGetNetworkMyip.js";
import { tool$networkGetNetworkPing } from "./tools/networkGetNetworkPing.js";
import { tool$networkGetNetworkPingmyip } from "./tools/networkGetNetworkPingmyip.js";
import { tool$networkGetNetworkPortscan } from "./tools/networkGetNetworkPortscan.js";
import { tool$networkGetNetworkUrlstatus } from "./tools/networkGetNetworkUrlstatus.js";
import { tool$networkGetNetworkWhois } from "./tools/networkGetNetworkWhois.js";
import { tool$networkGetNetworkWxdomain } from "./tools/networkGetNetworkWxdomain.js";
import { tool$poemGetSaying } from "./tools/poemGetSaying.js";
import { tool$postSearchAggregate } from "./tools/postSearchAggregate.js";
import { tool$postSensitiveWordAnalyze } from "./tools/postSensitiveWordAnalyze.js";
import { tool$postSensitiveWordQuickCheck } from "./tools/postSensitiveWordQuickCheck.js";
import { tool$randomGetAnswerbookAsk } from "./tools/randomGetAnswerbookAsk.js";
import { tool$randomGetRandomImage } from "./tools/randomGetRandomImage.js";
import { tool$randomGetRandomString } from "./tools/randomGetRandomString.js";
import { tool$randomPostAnswerbookAsk } from "./tools/randomPostAnswerbookAsk.js";
import { tool$socialGetGithubRepo } from "./tools/socialGetGithubRepo.js";
import { tool$socialGetSocialBilibiliArchives } from "./tools/socialGetSocialBilibiliArchives.js";
import { tool$socialGetSocialBilibiliLiveroom } from "./tools/socialGetSocialBilibiliLiveroom.js";
import { tool$socialGetSocialBilibiliReplies } from "./tools/socialGetSocialBilibiliReplies.js";
import { tool$socialGetSocialBilibiliUserinfo } from "./tools/socialGetSocialBilibiliUserinfo.js";
import { tool$socialGetSocialBilibiliVideoinfo } from "./tools/socialGetSocialBilibiliVideoinfo.js";
import { tool$socialGetSocialQqGroupinfo } from "./tools/socialGetSocialQqGroupinfo.js";
import { tool$socialGetSocialQqUserinfo } from "./tools/socialGetSocialQqUserinfo.js";
import { tool$statusGetStatusRatelimit } from "./tools/statusGetStatusRatelimit.js";
import { tool$statusGetStatusUsage } from "./tools/statusGetStatusUsage.js";
import { tool$textGetTextMd5 } from "./tools/textGetTextMd5.js";
import { tool$textPostTextAesDecrypt } from "./tools/textPostTextAesDecrypt.js";
import { tool$textPostTextAesDecryptAdvanced } from "./tools/textPostTextAesDecryptAdvanced.js";
import { tool$textPostTextAesEncrypt } from "./tools/textPostTextAesEncrypt.js";
import { tool$textPostTextAesEncryptAdvanced } from "./tools/textPostTextAesEncryptAdvanced.js";
import { tool$textPostTextAnalyze } from "./tools/textPostTextAnalyze.js";
import { tool$textPostTextBase64Decode } from "./tools/textPostTextBase64Decode.js";
import { tool$textPostTextBase64Encode } from "./tools/textPostTextBase64Encode.js";
import { tool$textPostTextConvert } from "./tools/textPostTextConvert.js";
import { tool$textPostTextMd5 } from "./tools/textPostTextMd5.js";
import { tool$textPostTextMd5Verify } from "./tools/textPostTextMd5Verify.js";
import { tool$translateGetAiTranslateLanguages } from "./tools/translateGetAiTranslateLanguages.js";
import { tool$translatePostAiTranslate } from "./tools/translatePostAiTranslate.js";
import { tool$translatePostTranslateStream } from "./tools/translatePostTranslateStream.js";
import { tool$translatePostTranslateText } from "./tools/translatePostTranslateText.js";
import { tool$webParseGetWebparseExtractimages } from "./tools/webParseGetWebparseExtractimages.js";
import { tool$webParseGetWebparseMetadata } from "./tools/webParseGetWebparseMetadata.js";
import { tool$webParseGetWebTomarkdownAsyncStatus } from "./tools/webParseGetWebTomarkdownAsyncStatus.js";
import { tool$webParsePostWebTomarkdownAsync } from "./tools/webParsePostWebTomarkdownAsync.js";

export function createMCPServer(deps: {
  logger: ConsoleLogger;
  allowedTools?: string[] | undefined;
  dynamic?: boolean | undefined;
  scopes?: MCPScope[] | undefined;
  getSDK?: () => UapiMcpCore;
  serverURL?: string | undefined;
  security?: SDKOptions["security"] | undefined;
  serverIdx?: SDKOptions["serverIdx"] | undefined;
}) {
  const server = new McpServer({
    name: "Uapi Mcp",
    version: "0.1.0",
    websiteUrl: "https://uapis.cn/docs",
  }, {
    instructions: [
      "推荐以 dynamic 模式运行。",
      "首次使用时，建议先调用 list_tools 和 describe_tool_input，再按需执行 execute_tool。",
      "如果工具返回积分不足、额度不足、credit 不够或 quota 用完，请直接提醒用户注册 UapiPro 账号：https://uapipro.cn。注册后请引导用户到 UapiPro 控制台创建 UAPI Key，再把 Key 填到 MCP 后台的 `uapikey` 配置里，这样就可以继续免费使用。长期使用也很便宜。",
      "如果需要管理员能力，再补充 `UapiAdminBearerAuth`。",
    ].join("\n"),
  });

  const getClient = deps.getSDK || (() =>
    new UapiMcpCore({
      security: deps.security,
      serverURL: deps.serverURL,
      serverIdx: deps.serverIdx,
      debugLogger: deps.logger.level === "debug"
        ? {
          log: (...args) => console.log(...args),
          group: (...args) => console.group(...args),
          groupEnd: (...args) => console.groupEnd(...args),
        }
        : undefined,
    }));

  const scopes = new Set(deps.scopes);

  const allowedTools = deps.allowedTools && new Set(deps.allowedTools);
  const [tool, tools, toolMap] = createRegisterTool(
    deps.logger,
    server,
    getClient,
    scopes,
    allowedTools,
    deps.dynamic,
  );
  const resource = createRegisterResource(
    deps.logger,
    server,
    getClient,
    scopes,
  );
  const resourceTemplate = createRegisterResourceTemplate(
    deps.logger,
    server,
    getClient,
    scopes,
  );
  const prompt = createRegisterPrompt(deps.logger, server, getClient, scopes);
  const register = { tool, resource, resourceTemplate, prompt };
  void register; // suppress unused warnings

  tool(tool$convertPostConvertJson);
  tool(tool$convertGetConvertUnixtime);
  tool(tool$dailyGetDailyNewsImage);
  tool(tool$gameGetGameMinecraftHistoryid);
  tool(tool$gameGetGameMinecraftServerstatus);
  tool(tool$gameGetGameMinecraftUserinfo);
  tool(tool$gameGetGameSteamSummary);
  tool(tool$gameGetGameEpicFree);
  tool(tool$imageGetImageBingDaily);
  tool(tool$imagePostImageFrombase64);
  tool(tool$imageGetImageMotou);
  tool(tool$imagePostImageMotou);
  tool(tool$imagePostImageSpeechless);
  tool(tool$imageGetImageQrcode);
  tool(tool$imageGetImageTobase64);
  tool(tool$imagePostImageSvg);
  tool(tool$imagePostImageCompress);
  tool(tool$imageGetAvatarGravatar);
  tool(tool$imagePostImageNsfw);
  tool(tool$miscGetMiscHotboard);
  tool(tool$miscGetMiscPhoneinfo);
  tool(tool$miscGetMiscRandomnumber);
  tool(tool$miscGetMiscTimestamp);
  tool(tool$miscGetMiscWeather);
  tool(tool$miscGetMiscWorldtime);
  tool(tool$miscGetMiscLunartime);
  tool(tool$miscGetMiscHolidayCalendar);
  tool(tool$miscGetHistoryProgrammerToday);
  tool(tool$miscGetHistoryProgrammer);
  tool(tool$miscGetMiscTrackingQuery);
  tool(tool$miscGetMiscTrackingDetect);
  tool(tool$miscGetMiscTrackingCarriers);
  tool(tool$miscPostMiscDateDiff);
  tool(tool$miscGetMiscDistrict);
  tool(tool$networkGetNetworkDns);
  tool(tool$networkGetNetworkIcp);
  tool(tool$networkGetNetworkIpinfo);
  tool(tool$networkGetNetworkMyip);
  tool(tool$networkGetNetworkPing);
  tool(tool$networkGetNetworkPingmyip);
  tool(tool$networkGetNetworkPortscan);
  tool(tool$networkGetNetworkUrlstatus);
  tool(tool$networkGetNetworkWhois);
  tool(tool$networkGetNetworkWxdomain);
  tool(tool$poemGetSaying);
  tool(tool$randomGetRandomImage);
  tool(tool$randomGetRandomString);
  tool(tool$randomGetAnswerbookAsk);
  tool(tool$randomPostAnswerbookAsk);
  tool(tool$socialGetSocialBilibiliUserinfo);
  tool(tool$socialGetSocialQqUserinfo);
  tool(tool$socialGetSocialBilibiliArchives);
  tool(tool$socialGetSocialBilibiliVideoinfo);
  tool(tool$socialGetSocialBilibiliReplies);
  tool(tool$socialGetSocialBilibiliLiveroom);
  tool(tool$socialGetSocialQqGroupinfo);
  tool(tool$socialGetGithubRepo);
  tool(tool$statusGetStatusRatelimit);
  tool(tool$statusGetStatusUsage);
  tool(tool$textPostTextAesDecrypt);
  tool(tool$textPostTextAesEncrypt);
  tool(tool$textPostTextAnalyze);
  tool(tool$textPostTextBase64Decode);
  tool(tool$textPostTextBase64Encode);
  tool(tool$textGetTextMd5);
  tool(tool$textPostTextMd5);
  tool(tool$textPostTextMd5Verify);
  tool(tool$textPostTextAesEncryptAdvanced);
  tool(tool$textPostTextAesDecryptAdvanced);
  tool(tool$textPostTextConvert);
  tool(tool$translatePostTranslateText);
  tool(tool$translatePostAiTranslate);
  tool(tool$translateGetAiTranslateLanguages);
  tool(tool$translatePostTranslateStream);
  tool(tool$webParseGetWebparseExtractimages);
  tool(tool$webParseGetWebparseMetadata);
  tool(tool$webParsePostWebTomarkdownAsync);
  tool(tool$webParseGetWebTomarkdownAsyncStatus);
  tool(tool$clipzyPostClipzyStore);
  tool(tool$clipzyGetClipzyGet);
  tool(tool$clipzyGetClipzyRaw);
  tool(tool$postSearchAggregate);
  tool(tool$getSearchEngines);
  tool(tool$postSensitiveWordAnalyze);
  tool(tool$getSensitiveWordAnalyzeQuery);
  tool(tool$postSensitiveWordQuickCheck);

  if (deps.dynamic) {
    registerDynamicTools(deps.logger, server, getClient, toolMap, scopes);
  }

  return { server, tools };
}
